export const JobItemComponent = ({
	jobTitle,
	jobCode,
	onSelect,
}: {
	jobTitle: string;
	jobCode: string;
	onSelect: () => void;
}) => {
	return (
		<div
			onClick={onSelect}
			className="p-2 bg-blue-100 rounded cursor-pointer transition-colors active:bg-blue-200"
		>
			<div className="text-lg">{jobTitle}</div>
			<div className=" text-gray-500 text-sm">{jobCode}</div>
		</div>
	);
};
